import React from "react";
import Checkbox from "../Checkbox/Checkbox";
import TextInputForSelect from "../TextInputForSelect/TextInputForSelect";
import "./MultiSelectCheckbox.css";

class MultiSelectCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
      value: "",
    };
    this.options = React.createRef();
    this.input = React.createRef();
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleCheckboxOnClick = this.handleCheckboxOnClick.bind(this);
  }

  componentDidMount() {
    if (this.props.data) {
      if (this.props.checkedValues && this.props.checkedValues.length > 0) {
        const changedData = [];
        console.log("hello");
        this.props.data.forEach((dataValue) => {
          const result = this.props.checkedValues.find(
            (v) => v === dataValue.value
          );
          if (result) {
            changedData.push({
              id: dataValue.id,
              value: dataValue.value,
              isChecked: true,
            });
          } else {
            changedData.push({
              id: dataValue.id,
              value: dataValue.value,
              isChecked: false,
            });
          }
        });
        this.setState({
          data: changedData,
        });
      } else {
        this.setState({
          data: this.props.data.map((d) => ({
            id: d.id,
            value: d.value,
            isChecked: false,
          })),
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.checkedValues !== prevProps.checkedValues) {
      if (this.props.checkedValues.length > 0) {
        const changedData = [];
        this.props.data.forEach((dataValue) => {
          const result = this.props.checkedValues.find(
            (v) => v === dataValue.value
          );
          if (result) {
            changedData.push({
              id: dataValue.id,
              value: dataValue.value,
              isChecked: true,
            });
          } else {
            changedData.push({
              id: dataValue.id,
              value: dataValue.value,
              isChecked: false,
            });
          }
        });
        if (this.props.checkedValues.length > 2) {
          if (this.props.keyword) {
            this.setState({
              value: `${this.props.checkedValues.length} ${this.props.keyword} selected`,
              data: changedData,
            });
          } else {
            this.setState({
              value: `${this.props.checkedValues.length} items selected`,
              data: changedData,
            });
          }
        } else {
          this.setState({
            value: this.props.checkedValues.join(", "),
            data: changedData,
          });
        }
      } else {
        this.setState({
          value: "",
          data: this.props.data.map((dataValue) => ({
            id: dataValue.id,
            value: dataValue.value,
            isChecked: false,
          })),
        });
      }
    }
  }

  handleOnClick(e) {
    e.stopPropagation();
    if (this.state.menuIsOpen === false) {
      this.setState(
        {
          menuIsOpen: true,
        },
        () => {
          document.addEventListener("click", this.handleOutsideClick);
        }
      );
    } else {
      this.setState(
        {
          menuIsOpen: false,
        },
        () => {
          document.addEventListener("click", this.handleOutsideClick);
        }
      );
    }
  }

  handleOutsideClick(e) {
    let target = e.target;
    if (
      this.input.current === target ||
      this.options.current === target ||
      this.options.current.contains(target)
    ) {
      return;
    } else {
      this.setState(
        {
          menuIsOpen: false,
        },
        () => {
          document.removeEventListener("click", this.handleOutsideClick);
        }
      );
    }
  }

  handleCheckboxOnClick(value) {
    const data = [...this.state.data];
    const dataValue = data.find((d) => d.value === value);
    if (dataValue) {
      const ind = data.indexOf(dataValue);
      if (data[ind].isChecked === false) {
        data[ind].isChecked = true;
      } else {
        data[ind].isChecked = false;
      }

      this.setState({
        data,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  render() {
    return (
      <div className="multiselect-checkbox select-input selector">
        {this.props.label ? (
          <label htmlFor={this.props.inputName}>{this.props.label}</label>
        ) : null}
        <TextInputForSelect
          menuIsOpen={this.state.menuIsOpen}
          handleInputClick={this.handleOnClick}
          readOnly={true}
          name={this.props.name}
          value={this.state.value}
          placeholder={this.props.placeholder}
          ref={this.input}
          id={this.props.inputName}
        />
        {this.state.data ? (
          <ul
            style={{ zIndex: this.props.zIndexValue }}
            ref={this.options}
            className={
              this.state.menuIsOpen
                ? "select-options select-options-show"
                : "select-options"
            }
          >
            {this.state.data.map((dataValue, index) => (
              <li
                key={this.props.inputName + index}
                onClick={() => this.handleCheckboxOnClick(dataValue.value)}
              >
                <Checkbox
                  id={`${this.props.checkBoxId}_${dataValue.value}_${dataValue.id}`}
                  name={dataValue.value + "_checkbox"}
                  value={dataValue.value}
                  isChecked={dataValue.isChecked}
                  onChange={this.props.handleCheckboxOnChange}
                />
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    );
  }
}

export default MultiSelectCheckbox;
